<div id="main-container" class="display-flex">
    <div class="scroll-container" style="height: calc(100vh - 171px);" [ngStyle]="{'width.px': leftColumnWidth}"  *ngIf="isTreeContainerVisible">
            <app-tree-view #tree_view_component [nodes]="nodes" [selectedNode]="selectedNode" (nodeSelect)="onNodeSelect($event)"></app-tree-view>
    </div>
    <div id="resizerDivId" class="resizer" appResizable (resizing)="onResizing($event)" (resize)="onResize($event)" style="color:rgb(227, 232, 232);display: flex; align-items: center;">
        <button (click)="toggleTreeContainer()" title="Collapse tree view"
            style="background-color: transparent; border:0px;margin-left: -15px;color: black;"
            *ngIf="isTreeContainerVisible&&!isResizing"><i id="collapse" class="pi pi-chevron-left"></i></button>
        <button (click)="toggleTreeContainer()" title="Expand tree view"
            style="background-color: transparent;border:0px;margin-left: -5px;color: black;"
            *ngIf="!isTreeContainerVisible&&!isResizing"><i id="expand" class="pi pi-chevron-right"></i></button>
    </div>
    <div class="list-scroll-container" style="width: 100%;">
        <app-detailed-create-send-product-report-view #detail_view_component
            [fieldsErrorsControl]="getFieldsErrorsControl()" [selectedNode]="selectedNode"
            (buttonAction)="onButtonAction($event)" (removeNode)="onRemoveNode($event)"
            (modelChange)="onModelChange($event)" (selectedNodeChange)="onSelectedNodeChange($event)"
            (goToSelectedNode)="onGoToSelectedNode($event)"></app-detailed-create-send-product-report-view>
    </div>
</div>